import {match as matchPath} from '@reach/router/lib/utils';

// be graceful even if no location provided
export const matchLocation = (route, location) =>
    location == null ? false : !!matchPath(route, location.pathname);
